import React from 'react';
import type {DetailsModalDifferentValuesProps} from './types';
import {Stack} from '@mui/material';
import {DataInfo} from 'presentation/components';
import {useTheme} from 'styled-components';
import {translations} from 'presentation/translations-new';

const {totalSessionsValue, totalDocument} = translations['pt-br'].privateFlow.refund.therapies;

export const DetailsModalDifferentValues = ({
	totalValueDocument,
	totalValueTherapies,
}: DetailsModalDifferentValuesProps) => {
	const {colors} = useTheme();
	return (
		<Stack sx={{flexDirection: 'row', width: '100%'}}>
			<DataInfo
				primaryText={totalSessionsValue}
				primaryTextColor={colors.light.text.secondary}
				primaryTextFontSize="14px"
				secondaryText={totalValueTherapies}
				secondaryTextFontSize="16px"
				iconName="assignment-outline"
			/>
			<DataInfo
				primaryText={totalDocument}
				primaryTextColor={colors.light.text.secondary}
				primaryTextFontSize="14px"
				secondaryText={totalValueDocument}
				secondaryTextFontSize="16px"
				iconName="barcode-default"
				listItemProps={{
					sx: {
						borderLeft: `1px solid ${colors.gray['20Percent']}`,
						paddingLeft: '16px',
						paddingBlock: 0,
					},
				}}
			/>
		</Stack>
	);
};
